import { useState } from "react"

import { AppButton } from "components/AppButton"
import { AppLayoutTable } from "components/AppLayoutTable"
import { AppModal } from "components/AppModal"
import { AppPagination } from "components/AppPagination"
import { AppTable } from "components/AppTable"
import { usePagination } from "hooks/usePagination"
import { CalculatorType } from "models/payout"
import { PayoutApi } from "services/api/PayoutApi"

import { CalculatorDetails } from './_components/CalculatorDetails'
import { CalculatorDetailsEmpty } from './_components/CalculatorDetailsEmpty'

export const CalculatorsPage = () => {
  const [details, setDetails] = useState<CalculatorType | null>(null)
  const [deletingId, setDeletingId] = useState<number | null>(null)
  const { page, list, count, getList } = usePagination(PayoutApi.getCalcs)

  const openDetails = async (payoutUser: CalculatorType) => {
    try {
      if (payoutUser.id === details?.id) {
        return;
      }
      closeDetails();
      setDetails(payoutUser);
    } catch (error) {
    }
  };

  const onDelete = (id: number) => {
    PayoutApi.deleteCalc(id).then(() => {
      getList(page)
      setDeletingId(null)
    })
  }

  const closeDetails = () => setDetails(null)

  return (
    <>
      {deletingId && (
        <AppModal onClose={() => setDeletingId(null)} title="Вы уверены?">
          <div style={{display: 'flex', padding: 20, gap: 20}}>
            <AppButton
              variant="red"
              size="small"
              onClick={() => onDelete(deletingId)}
            >Удалить</AppButton>
            <AppButton
              variant="siren"
              size="small"
              onClick={() => setDeletingId(null)}
            >Отменить</AppButton>
          </div>
        </AppModal>
      )}
      <AppLayoutTable
        title="Настройки"
        sidebarOpened={Boolean(details)}
        sidebar={
          details
            ? <CalculatorDetails data={details} onClose={closeDetails} />
            : <CalculatorDetailsEmpty />
        }>
        <AppTable
          dataSource={list}
          onClickRow={openDetails}
          selected={{
            value: details?.id,
            key: "id",
          }}
          headers={[
            {
              key: 'one_time_payout',
              data: 'Бонус за выдачу карты, сом'
            },
            {
              key: 'instant_payout',
              data: 'Сумма моментального бонуса, сом.'
            },
            {
              key: 'plan',
              data: 'План',
              render: item => item.name
            },
            {
              key: 'id',
              data: 'Действия',
              render: (_, item) => {
                return (
                  <AppButton
                    variant="red"
                    size="small"
                    onClick={() => setDeletingId(item.id)}
                  >Удалить</AppButton>
                )
              }
            },
          ]} />

        {count > 0 ? (
          <AppPagination
            forcePage={page - 1}
            onPageChange={getList}
            count={count}
          />
        ) : null}
      </AppLayoutTable>
    </>
  )
}